import Image from 'next/legacy/image';
import { oneLine } from 'common-tags';

import type { ImageProps } from 'next/image';
import type { FunctionComponent } from 'react';
import type { TypeDataSheetProps } from './types';

/**
 * DataSheet es un layout que permite mostrar datos
 * junto con una imagen a dos columnas
 */
export const DataSheet: FunctionComponent<TypeDataSheetProps> = ({
  title,
  image,
  imagePosition = 'left',
  className = '',
  children,
}: TypeDataSheetProps) => {
  const imageHTML = (
    <div
      className={`hidden bg-[#c4c4c433] md:flex md:justify-center ${imagePosition === 'right' ? '' : 'mt-16 flex flex-col'}`}
    >
      {image ? (
        <Image
          src={image.src}
          alt={image.alt ?? ''}
          width={image.width as ImageProps['width']}
          height={image.height as ImageProps['height']}
        />
      ) : null}
    </div>
  );

  const dataHTML = <div>{children}</div>;

  const [leftColumn, rightColumn] =
    imagePosition === 'left' ? [imageHTML, dataHTML] : [dataHTML, imageHTML];

  return (
    <div
      className={`grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-20 xl:gap-28 ${className}`}
    >
      <div className="flex flex-col">
        <span className="u-headline u-headline--h2 pb-4">{title}</span>

        {leftColumn}
      </div>
      <div
        className={oneLine`md:pt-10 ${
          imagePosition === 'right' ? 'hidden md:inline' : ''
        }`}
      >
        {rightColumn}
      </div>
    </div>
  );
};
